import React, { useState } from "react";

import Drawer from "./drawer";
import AppBar from "./toolbar";

const ManagerLayout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden", backgroundColor: "#F6F8FB" }}>
      <Drawer open={sidebarOpen} onToggle={() => setSidebarOpen((o) => !o)} />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", minWidth: 0 }}>
        <AppBar />
        <main style={{ flex: 1, overflowY: "auto", padding: "32px" }}>
          {props.children}
        </main>
      </div>
    </div>
  );
};

export default ManagerLayout;
